import { generateUUID } from '@/plugins/helper'

export class HardLoadingItem {
  readonly id: string
  readonly title: string
  readonly minimizable: boolean
  totalItems: number
  succeedItems: number

  constructor(title: string, totalItems: number = 0, minimizable: boolean = true, id: string = generateUUID()) {
    this.id = id
    this.title = title
    this.totalItems = totalItems
    this.succeedItems = 0
    this.minimizable = minimizable
  }

  updateSucceededCount(updated: number): void {
    if (updated < 0 || updated > this.totalItems) {
      throw new Error('Invalid updated count')
    }
    this.succeedItems = updated
  }

  markComplete(): void {
    this.succeedItems = this.totalItems
  }

  updateTotalItems(updated: number): void {
    if (updated < 0) {
      throw new Error('Invalid updated count')
    }
    this.totalItems = updated
  }

  get progress(): number {
    return this.totalItems > 0
      ? Math.round((this.succeedItems * 100) / this.totalItems)
      : 0
  }
}
